import { useContext } from 'react';
import { AlertContext } from 'contexts/AlertContext';

export function useAlert() {
  const state = useContext(AlertContext);
  return state;
}
